export var ENTITY = "rentRegistration";
export var REDUCER_KEY = "RENT_REGISTRATION_V2";
export var BASE_PATH_ENTITY = "rent-registrations";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
